import React, { useContext } from "react";
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";
import { ThemeContext } from "../../contexts/ThemeContext"; // adjust path if needed

function AdminFooter() {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  const footerStyle = {
    backgroundColor: isDark ? "#111" : "#f8f9fe",
    color: isDark ? "#ddd" : "#525f7f",
    borderTop: isDark ? "1px solid rgba(255,255,255,0.1)" : "1px solid #e9ecef",
    transition: "background-color 0.3s ease, color 0.3s ease",
    padding: "1rem 0",
  };

  const linkStyle = {
    color: isDark ? "#a0cfff" : "#007bff",
    transition: "color 0.3s ease",
  };

  const mutedText = {
    color: isDark ? "#aaa" : "#8898aa",
  };

  return (
    <Container fluid>
      <footer className="footer pt-0" style={footerStyle}>
        <Row className="align-items-center justify-content-lg-between">
          <Col lg="6">
            <div className="copyright text-center text-lg-left" style={mutedText}>
              © {new Date().getFullYear()}{" "}
              <a
                className="font-weight-bold ml-1"
                href="https://www.husariatech.com"
                target="_blank"
                rel="noopener noreferrer"
                style={linkStyle}
              >
                Husaria Technologies Inc.
              </a>
            </div>
          </Col>
          <Col lg="6">
            <Nav className="nav-footer justify-content-center justify-content-lg-end">
              <NavItem>
                <NavLink
                  href="https://www.husariatech.com/about"
                  target="_blank"
                  style={linkStyle}
                >
                  About Us
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="https://www.husariatech.com/aup"
                  target="_blank"
                  style={linkStyle}
                >
                  AUP
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="https://www.husariatech.com/privacy"
                  target="_blank"
                  style={linkStyle}
                >
                  Privacy Policy
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
      </footer>
    </Container>
  );
}

export default AdminFooter;
